const WellnessCalendarUtilizationCard = ({ title = '', date = '', time = '', liner = '', classes='', svgsrc }) => {
  return (
    <div className={'border bg-white border-gray-275 rounded-lg flex flex-row inline-block items-center ' + classes}>
      <img src={svgsrc} className='h-20 w-20 wellness-calendar-bronken' />
      <div className="flex flex-col">
        <h1 className='text-lg text-gray-700 mb-0 font-semibold' style={{ lineHeight: 1.3 }}>{title}</h1>
        <p className='font-normal text-sm text-gray-600 mb-0 mt-1'>{`${date} | ${time}`}</p>
        <p className='font-normal text-sm text-gray-500 mb-0 mt-1.5'>{liner}</p>
      </div>
    </div>
  )
}

export default WellnessCalendarUtilizationCard